import React, { useState, useEffect } from "react";
import "./App.css";
import play from "./play.svg";
import stop from "./stop.svg";
import pause from "./pause.svg";
import MultiStreamsMixer from "multistreamsmixer";

var videoPreview = document.querySelector("video");
var mixerOptions = {};
var mixer;
var mediaRecorder;
var recordedBlobs;

function App() {
  const [permissionAllowed, setPermission] = useState(false);
  const [started, setStart] = useState(false);

  useEffect(() => {
    let handlePermission = async () => {
      mixerOptions.value = "camera-screen";
      let camera = await cameraStream();
      if (camera === null) {
        setPermission(false);
      } else {
        setPermission(true);
      }
    };
    handlePermission();
  }, [permissionAllowed]);

  function addStreamStopListener(stream, callback) {
    stream.addEventListener(
      "ended",
      function () {
        callback();
        callback = function () {};
      },
      false
    );
    stream.addEventListener(
      "inactive",
      function () {
        callback();
        callback = function () {};
      },
      false
    );
    stream.getTracks().forEach(function (track) {
      track.addEventListener(
        "ended",
        function () {
          callback();
          callback = function () {};
        },
        false
      );
      track.addEventListener(
        "inactive",
        function () {
          callback();
          callback = function () {};
        },
        false
      );
    });
  }

  function afterScreenCaptured(screenStream) {
    navigator.mediaDevices
      .getUserMedia({
        video: {
          width: 160,
          height: 120,
          frameRate: 15,
        },
        audio: true,
      })
      .then(async function (cameraStream) {
        screenStream.fullcanvas = true;
        screenStream.width = 1920; // or 3840
        screenStream.height = 1080; // or 2160

        cameraStream.width = parseInt((15 / 100) * screenStream.width);
        cameraStream.height = parseInt((15 / 100) * screenStream.width);
        cameraStream.top = screenStream.height - cameraStream.height;
        cameraStream.left = screenStream.width - cameraStream.width;

        mixer = new MultiStreamsMixer([screenStream, cameraStream]);

        mixer.frameInterval = 1;
        mixer.startDrawingFrames();
        videoPreview = document.querySelector("video");
        videoPreview.srcObject = mixer.getMixedStream();
        recordedBlobs = [];
        let options = { mimeType: "video/webm;codecs=vp9,opus" };
        if (!MediaRecorder.isTypeSupported(options.mimeType)) {
          console.error(`${options.mimeType} is not supported`);
          options = { mimeType: "video/webm;codecs=vp8,opus" };
          if (!MediaRecorder.isTypeSupported(options.mimeType)) {
            console.error(`${options.mimeType} is not supported`);
            options = { mimeType: "video/webm" };
            if (!MediaRecorder.isTypeSupported(options.mimeType)) {
              console.error(`${options.mimeType} is not supported`);
              options = { mimeType: "" };
            }
          }
        }

        try {
          mediaRecorder = new MediaRecorder(mixer.getMixedStream(), options);
        } catch (e) {
          console.error("Exception while creating MediaRecorder:", e);
          return;
        }

        console.log(
          "Created MediaRecorder",
          mediaRecorder,
          "with options",
          options
        );
        mediaRecorder.onstop = async (event) => {
          console.log("Recorder stopped: ", event);
          console.log("Recorded Blobs: ", recordedBlobs);
          mixer.releaseStreams();
          videoPreview.pause();
          videoPreview.src = null;
          if (videoPreview === document.pictureInPictureElement) {
            await document.exitPictureInPicture();
          }
          cameraStream.getTracks().forEach(function (track) {
            track.stop();
          });
          screenStream.getTracks().forEach(function (track) {
            track.stop();
          });
          download();
        };
        mediaRecorder.ondataavailable = handleDataAvailable;
        mediaRecorder.start();
        console.log("MediaRecorder started", mediaRecorder);
        setStart(true);
        // stop listner
        addStreamStopListener(screenStream, async function () {
          if (mediaRecorder.state !== "inactive") {
            mediaRecorder.stop();
            mixer.releaseStreams();
            videoPreview.pause();
            videoPreview.src = null;
            if (videoPreview === document.pictureInPictureElement) {
              await document.exitPictureInPicture();
            }
            cameraStream.getTracks().forEach(function (track) {
              track.stop();
            });
            screenStream.getTracks().forEach(function (track) {
              track.stop();
            });
          }
        });
      });
  }

  function getMixedCameraAndScreen() {
    if (permissionAllowed) {
      if (navigator.getDisplayMedia) {
        navigator.getDisplayMedia({ video: true }).then((screenStream) => {
          afterScreenCaptured(screenStream);
        });
      } else if (navigator.mediaDevices.getDisplayMedia) {
        navigator.mediaDevices
          .getDisplayMedia({ video: true })
          .then((screenStream) => {
            afterScreenCaptured(screenStream);
          });
      } else {
        alert("getDisplayMedia API is not supported by this browser.");
      }
    }
  }

  async function cameraStream() {
    let captureStream = null;
    try {
      captureStream = await navigator.mediaDevices.getUserMedia({
        audio: true,
        video: true,
      });
    } catch (err) {
      console.error("Error: " + err);
    }
    return captureStream;
  }

  function startRecording() {
    getMixedCameraAndScreen();
  }

  function handleDataAvailable(event) {
    console.log("handleDataAvailable", event);
    if (event.data && event.data.size > 0) {
      recordedBlobs.push(event.data);
    }
  }

  function stopRecording() {
    mediaRecorder.stop();
  }

  async function download() {
    const blob = new Blob(recordedBlobs, { type: "video/webm" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = url;
    a.download = new Date().getTime() + ".webm";
    document.body.appendChild(a);
    a.click();
    setTimeout(() => {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 100);
    setStart(false);
    videoPreview.pause();
    videoPreview.src = null;
  }

  return (
    <div className="App">
      <h2>Screeny</h2>
      <p className="info">
        Not supported in small devices. Please open in desktop browser
      </p>
      <p style={{ textAlign: "center" }}>
        Supported Browser:{" "}
        <a
          href="https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getDisplayMedia"
          target="_blank"
          rel="noopener noreferrer"
        >
          Screen Capture
        </a>
        ,{" "}
        <a
          href="https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices"
          target="_blank"
          rel="noopener noreferrer"
        >
          Camera & Audio
        </a>
      </p>
      <div className="layout">
        {!permissionAllowed && (
          <div>
            <video
              src=""
              style={{ backgroundColor: "#444", height: 200 }}
            ></video>
            <p>
              <span style={{ fontWeight: 600 }}>Note: </span>You need to allow
              camera & audio permission to start recording. 
            </p>
            <p>
              <span style={{ fontWeight: 400 }}>Not Working? </span> Please refresh the page.
            </p>
          </div>
        )}
        {permissionAllowed && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
              height: "100%",
            }}
          >
            <video
              id="video"
              style={{ height: "70%", backgroundColor: "#444" }}
              autoPlay
              muted
              playsInline
            >
              Your browser does not support the video tag.
            </video>
            {/* <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "center",
                marginTop: 16,
              }}
            >
              <span>
                Camera
                <select
                  placeholder="Select Camera Position"
                  style={{ padding: "4px 8px", marginLeft: 8 }}
                >
                  <option>Top right</option>
                  <option>Top left</option>
                  <option>Bottom right</option>
                  <option>Bottom Left</option>
                </select>
              </span>
            </div> */}
            <div
              style={{
                display: "flex",
                width: "100%",
                justifyContent: "space-between",
                marginTop: 24,
              }}
            >
              {!started && (
                <button
                  style={{
                    border: "1px solid #111",
                    borderRadius: 4,
                    cursor: "pointer",
                    margin: "auto",
                    fontSize: 16,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 8,
                    width: 100,
                    backgroundColor: "#fff",
                  }}
                  onClick={() => startRecording()}
                >
                  <img
                    src={play}
                    alt="play"
                    style={{ height: 36, marginRight: 8 }}
                  ></img>{" "}
                  Start
                </button>
              )}
              {/* {started && (
                <button
                  style={{
                    border: "1px solid #111",
                    borderRadius: 4,
                    cursor: "pointer",
                    margin: "auto",
                    fontSize: 16,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 8,
                    width: 120,
                    backgroundColor: "#fff",
                  }}
                >
                  <img
                    src={pause}
                    alt="pause"
                    style={{ height: 36, marginRight: 8 }}
                  ></img>{" "}
                  Pause
                </button>
              )} */}
              {started && (
                <button
                  style={{
                    border: "1px solid #111",
                    borderRadius: 4,
                    cursor: "pointer",
                    margin: "auto",
                    fontSize: 16,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    padding: 8,
                    width: 180,
                    backgroundColor: "#fff",
                  }}
                  onClick={() => stopRecording()}
                >
                  <img
                    src={stop}
                    alt="stop"
                    style={{ height: 36, marginRight: 8 }}
                  ></img>{" "}
                  Stop & Save
                </button>
              )}
            </div>
          </div>
        )}
      </div>
      <p style={{ textAlign: "center", marginTop: 24 }}>
        Devloped by{" "}
        <a
          href="https://github.com/anket11?tab=repositories"
          target="_blank"
          rel="noopener noreferrer"
        >
          Anket
        </a>
      </p>
    </div>
  );
}

export default App;
